import './cta-block.scss';

export default () => {
	let parallaxElement = $( ".parallax-image" )

	parallaxElement.each( ( i, img ) => {
		img.movement = Math.random() * -.2 -.1
	} )

	$( window ).on( "load scroll", function() {
		window.requestAnimationFrame( function() {
			parallaxElement.each( ( i, img ) => {
				let windowTop = $( window ).scrollTop()
				let elementTop = $(img).offset().top
				let elementHeight = $(img).height()
				let viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5
				let scrolled = windowTop - elementTop + viewPortHeight
				$(img).css( {
					transform: "translateY(" + scrolled * img.movement + "px)"
				} );
			} )
		} );
	} );

};
